import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';
import { auth } from '../config/firebase';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redirect to verify-email if email is not verified.
  // Fall back to auth.currentUser — Firebase's singleton is authoritative
  // and avoids bouncing the user when React state from reloadUser hasn't
  // yet propagated through context.
  const isVerified = user.emailVerified || auth.currentUser?.emailVerified;
  if (!isVerified) {
    return <Navigate to="/verify-email" state={{ email: user.email, from: location }} replace />;
  }

  /*
   * No plan check here. The web has a free tier again (October 2026), so an unpaid account
   * belongs inside the product like any other; each feature meters itself on the API and offers
   * the upgrade at the moment a limit is reached. The hard-paywall redirect that lived here sent
   * every new account to /paywall before it had seen anything — see paywall.middleware.ts for
   * what that did to activation.
   */
  return children;
}
